import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { muiTheme } from '@mploy/styles';
import { PostHogProvider } from '@posthog/react';
import { UserProvider } from '../context/user.context';
import { LoggedInUser } from '../../../types/auth.types';

export type AppRootProps = {
    children: JSX.Element | JSX.Element[]
    user?: LoggedInUser
}

const options = {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
} as const;

const postHogApiKey = 'phc_vmcfAjXbce6YFYXQVpEnyotHzrcvYRIHSkMDuhGxaxU';

const AppRoot = (props: AppRootProps): JSX.Element => <>
    <PostHogProvider apiKey={postHogApiKey} options={options}>
        <ThemeProvider theme={muiTheme}>
            <CssBaseline />
            <UserProvider value={props.user}>
                {props.children}
            </UserProvider>
        </ThemeProvider>
    </PostHogProvider>
</>;

export default AppRoot;
